RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    views.LandscapePicker = RivalIQ.views.ItemView.extend({
        template: '#userLandscapePickerTemplate',

        behaviors: {
            FormValidator: {
                bindModel: false
            },
            AttributeBuilder: {}
        },

        loadData: function (cb) {
            const me = this;
            RivalIQ.data.landscapes.fetch(RivalIQ.state.account)
                .done(function (landscapes) {
                    me.collection = landscapes;
                    cb();
                });
        },

        serializeData: function () {
            const me = this;
            const landscapes = me.collection.toJSON();
            const landscapeId = _.get(me.model.get('readonly_settings'), 'landscape_id', RivalIQ.state.landscape.id);
            const activeLandscape = _.find(landscapes, {
                id: landscapeId
            });
            const sorted = _.reject(landscapes, {
                id: landscapeId
            });
            sorted.unshift(activeLandscape);

            return {
                activeLandscape: RivalIQ.state.landscape.id,
                landscapes: sorted
            };
        }
    });

    views.Edit = RivalIQ.views.LayoutView.extend({
        template: '#userEditTemplate',
        fields: [],

        regions: {
            landscapePicker: {
                selector: '.x-landscape-picker',
                allowMissingEl: true
            }
        },

        ui: {
            modal: '.modal',
            infoBubbles: '.fa-info-circle',
            saveBtn: '.x-save'
        },

        events: {
            'click @ui.saveBtn': 'onSave',
            'click .x-trigger-intercom': 'showIntercom',
            'shown.bs.modal': 'onModalShown',
            'keypress input': 'onKeypress'
        },

        behaviors: {
            AttributeBuilder: {},
            FormValidator: {
                bindModel: false
            }
        },

        title: function () {
            const me = this;
            return ['Edit', me.model.get('first_name'), me.model.get('last_name')].join(' ');
        },

        templateHelpers: function () {
            const me = this;

            let roles;

            if (me.getOption('rolesToShow')) {
                roles = me.getOption('rolesToShow');
            } else {
                roles = [RivalIQ.enums.roles.full];

                if (RivalIQ.state.account.inBeta('client_account')) {
                    roles.push(RivalIQ.enums.roles.readOnly);
                }

                if (!me.model.isNew() && me.model.isActive()) {
                    roles.unshift(RivalIQ.enums.roles.owner);
                }
            }

            let roleDescription = RivalIQ.strings.user_role_description;
            if (_.includes(roles, RivalIQ.enums.roles.readOnly)) {
                // append the client user role description if that role is included
                roleDescription += (` ${RivalIQ.strings.client_user_role_description}`);
            }

            return {
                s: s,
                roles: roles,
                user: me.model,
                title: function () {
                    const title = me.getOption('title');
                    return (_.isFunction(title) ? title.call(me) : title);
                },
                fields: function (name) {
                    return _.includes(me.getOption('fields'), name);
                },
                showRoles: function () {
                    return roles.length > 1 && RivalIQ.state.user.canEditField(me.model, 'role_id');
                },
                roleDescription: roleDescription,
                description: me.getOption('description')
            };
        },

        serializeData: function () {
            const me = this;

            return _.defaults(me.model.toJSON(), {
                first_name: '',
                last_name: ''
            });
        },

        onBeforeShow: function () {
            const me = this;
            me.requestRenderedFrame(function () {
                me.ui.infoBubbles.popover();

                me.landscapePicker.show(new views.LandscapePicker({
                    model: me.model
                }));

                me.onRoleFormChange(me.model.get('role_id'));
            });
        },

        onShow: function () {
            const me = this;
            me.$('input').first().focus();
        },

        onModalShown: function () {
            const me = this;
            me.$('input').first().focus();
        },

        onRoleFormChange: function (roleId) {
            const me = this;

            if (roleId === RivalIQ.enums.roles.readOnly.id) {
                return me.landscapePicker.$el.show();
            }
            me.landscapePicker.$el.hide();
        },

        onKeypress: function (e) {
            const me = this;

            if (e.keyCode === 13) {
                e.preventDefault();
                me.onSave();
            }
        },

        onSave: function () {
            const me = this;

            me.ui.saveBtn.button('loading');
            me.triggerMethod('resetValidationErrors');

            const attrs = _.extend({
                gdprMessage: me.$('.x-gdpr-msg').html(),
                isJoiningExistingAccount: true
            }, me.formAttrs);

            const result = me.model.save(attrs, {
                fields: me.getOption('fields')
            });

            if (!result) {
                return me.ui.saveBtn.button('reset');
            }

            result
                .done(function () {
                    me.triggerMethod('save:complete');
                })
                .fail(function (xhr) {
                    me.ui.saveBtn.button('reset');

                    if (xhr.errorName === 'WeakPasswordError') {
                        return me.triggerMethod('display:error', 'password', 'Your password must be at least 8 characters');
                    } else if (xhr.errorName === 'BadPasswordError') {
                        return me.triggerMethod('display:error', 'current_password', 'Incorrect Password');
                    } else if (xhr.errorName === 'BadEmailAddressError') {
                        return me.triggerMethod('display:error', 'email', 'Invalid Email');
                    } else if (xhr.errorName === 'EmailAlreadyExistsError') {
                        return me.onEmailCollision();
                    } else if (xhr.errorName === 'UserLimitReachedError') {
                        return me.triggerMethod('display:error', 'email', 'You have hit the user limit for this account');
                    }

                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        },

        onEmailCollision: function () {
            const me = this;
            me.triggerMethod('display:error', 'email', 'A user already exists with that email');
        },

        showIntercom: function () {
            if (window.Intercom) {
                window.Intercom('show');
            }
        },

        initialize: function () {
            const me = this;
            me.listenTo(me.model, 'form:role_id', me.onRoleFormChange);
        }
    });

}, window.s);
